import _Rubn5O8YXA2u0fgzXwb2 from '../dictionary/access-key-creation-form-schema.json' with { type: 'json' };
import _qDuWj4yX0RhG8PsfOC1d from '../dictionary/access-key-creation-form.json' with { type: 'json' };
import _dOZN9bmrqoOTLekpJOYJ from '../dictionary/access-key-form.json' with { type: 'json' };
import _zwSZb2BTsHDK1brvQ8Sz from '../dictionary/ai-ab-testing-section.json' with { type: 'json' };
import _QpCa8F5wP4N6xWBj4Ky0 from '../dictionary/application-not-running-view.json' with { type: 'json' };
import _hoDDBdKXlbehy8u2g4H0 from '../dictionary/application-template-message.json' with { type: 'json' };
import _n99tfC1RKl3WZHbG4qHU from '../dictionary/aside-navigation.json' with { type: 'json' };
import _SStx8Rd5g7uDVYhNdx2i from '../dictionary/ask-reset-password-schema.json' with { type: 'json' };
import _KD0dTbTzVxqEIuIXxJCZ from '../dictionary/ask-reset-password.json' with { type: 'json' };
import _1HXkcSnhOewJ1ZoMRr1V from '../dictionary/autocompletion-section.json' with { type: 'json' };
import _PvWAhm67jGuGhOKyUDlT from '../dictionary/available-techno-section.json' with { type: 'json' };
import _ZrbFBgGlh1vY2AbJIfN8 from '../dictionary/blog-data.json' with { type: 'json' };
import _0yYhbxbyrZXFwwkxbiZg from '../dictionary/blog-metadata.json' with { type: 'json' };
import _EnLAfOcC6eW2vDDCqAgb from '../dictionary/blog-nav-list.json' with { type: 'json' };
import _oOBrVk7CYo9517M8K21T from '../dictionary/blog-page.json' with { type: 'json' };
import _Kk1MDtOghdDAFRvzpSPd from '../dictionary/blog-search-metadata.json' with { type: 'json' };
import _7ozVyNKLad965Ci4ittQ from '../dictionary/blog-search-page.json' with { type: 'json' };
import _cuV5vovyi4XLkUjfv95R from '../dictionary/breadcrumb.json' with { type: 'json' };
import _H8VJUHXfjRo0MUa9oit0 from '../dictionary/change-password-form-schema.json' with { type: 'json' };
import _1XxZ7C69o55Dik2V14O4 from '../dictionary/change-password-form.json' with { type: 'json' };
import _4wWNCRrDapFlRwepYAJT from '../dictionary/change-password-metadata.json' with { type: 'json' };
import _zngZDP7S5Io3oVLH1U4t from '../dictionary/change-password-page.json' with { type: 'json' };
import _zG283Lj2mWSk8tdmcfDv from '../dictionary/change-password-schema.json' with { type: 'json' };
import _ZXEkig8nriYIpKnOXJCx from '../dictionary/chat-form-related-files.json' with { type: 'json' };
import _TmxohlxNpZaRfXr0jxKJ from '../dictionary/chat-form-section-schema.json' with { type: 'json' };
import _nSIpJwgOVcdFA2yatCRe from '../dictionary/chat-form-section.json' with { type: 'json' };
import _DRWUOjQqAGAeWnimm3zp from '../dictionary/chat.json' with { type: 'json' };
import _vxPQ6fCHiBgUwBh1qaOb from '../dictionary/chatbot-modal.json' with { type: 'json' };
import _6DM8FNpdyHjHeBPQyYpK from '../dictionary/checking-application-status-view.json' with { type: 'json' };
import _S9UlbA7lXSQeJnTqCYg1 from '../dictionary/code.json' with { type: 'json' };
import _DPaz1eG00dA5ZDyVrcg9 from '../dictionary/common-questions.json' with { type: 'json' };
import _4fDHWULm1gXajqDSb7z5 from '../dictionary/confirmation-step.json' with { type: 'json' };
import _fjunpeKkZHQ2PT4ZNEmi from '../dictionary/content-dashboard-metadata.json' with { type: 'json' };
import _rv5tkZ6SV35wtu732rNo from '../dictionary/content-dashboard-page.json' with { type: 'json' };
import _DFzXxuXWvtF46pzT4Bja from '../dictionary/contribution-message.json' with { type: 'json' };
import _IIOKVlIhpT3qANCzKUoE from '../dictionary/copy-button.json' with { type: 'json' };
import _gGyuqhhLmfK9CEN5dH3V from '../dictionary/copy-markdown-message.json' with { type: 'json' };
import _fV9NxlqkiD724MnBwVGW from '../dictionary/creative-work-structured-data.json' with { type: 'json' };
import _G7pzOWc73BUWhfXFtd9l from '../dictionary/dashboard-footer.json' with { type: 'json' };
import _RURE2w802HgLU4gifh6g from '../dictionary/dashboard-metadata.json' with { type: 'json' };
import _2YPnvvo94LjGqic49gjg from '../dictionary/dashboard-navbar-content.json' with { type: 'json' };
import _f0IlBnDOrqvG27rBBcYY from '../dictionary/dashboard-navbar.json' with { type: 'json' };
import _zuJAuRCjHMdF6TZMFn3q from '../dictionary/dashboard-not-found-metadata.json' with { type: 'json' };
import _ujM32TFZL3odMNOQmL6r from '../dictionary/dashboard-page.json' with { type: 'json' };
import _Zo5txVhGAayAVaYAhCf9 from '../dictionary/define-password-form-schema.json' with { type: 'json' };
import _eswpsPWshJVsB6Dg9mpD from '../dictionary/define-password-form.json' with { type: 'json' };
import _VWpN5AtM9HjSVFc7rtNG from '../dictionary/define-password-schema.json' with { type: 'json' };
import _r2jO5XMZbTRQUolEwZFf from '../dictionary/define-password-step.json' with { type: 'json' };
import _CNcknTFEjXDqnIUf9XP1 from '../dictionary/delete-organization-modal.json' with { type: 'json' };
import _bJXz9XOof6DY8ka4HJmu from '../dictionary/delete-project-modal.json' with { type: 'json' };
import _RfND88POX3Kon4BE6L7U from '../dictionary/delete-tag-modal.json' with { type: 'json' };
import _5tA8DSvPYbi88Ratx0y9 from '../dictionary/demo-metadata.json' with { type: 'json' };
import _6hXQMVDjVsdGK7xZjQx0 from '../dictionary/demo-page.json' with { type: 'json' };
import _gIk1zGlGNgsRU15suzNI from '../dictionary/demo-section.json' with { type: 'json' };
import _82aWgK59kQ7zMcQPNOaz from '../dictionary/dictionary-dashboard-page.json' with { type: 'json' };
import _UTmzxtqEhL6wZLtpG4Uy from '../dictionary/dictionary-detail-schema.json' with { type: 'json' };
import _JW9tWj8MQQ6hyrw8SQig from '../dictionary/dictionary-details.json' with { type: 'json' };
import _SLU18jMAUfibbMzixryz from '../dictionary/dictionary-edition-drawer.json' with { type: 'json' };
import _kHdY9BDpbfTBNYC2kDja from '../dictionary/dictionary-field-editor.json' with { type: 'json' };
import _RxrBkOPTfxqSf8R6qJ9w from '../dictionary/dictionary-form-schema.json' with { type: 'json' };
import _W5HL7v534FXijqAH38Lr from '../dictionary/dictionary-form.json' with { type: 'json' };
import _7kZ5YMkTxk1Fg7uin7rq from '../dictionary/dictionary-list-drawer.json' with { type: 'json' };
import _dLmfDoQjKGI1ssgc3nz9 from '../dictionary/doc-chat-metadata.json' with { type: 'json' };
import _yJLfeAGJmRUuqjojKBmx from '../dictionary/doc-chat-page.json' with { type: 'json' };
import _icrW9FhwyTfQIxYOnzO6 from '../dictionary/doc-data.json' with { type: 'json' };
import _B6XvgSSUlwjG4e0ZZlW1 from '../dictionary/doc-header.json' with { type: 'json' };
import _IgBufdtIXdaOre68fnNC from '../dictionary/doc-metadata.json' with { type: 'json' };
import _zB10Frhg2ujd3JP0gQPa from '../dictionary/doc-nav-list.json' with { type: 'json' };
import _uC12y7L5eSgZoywNrNxz from '../dictionary/doc-page.json' with { type: 'json' };
import _LFwhe21VVbv2IWn8lI1x from '../dictionary/doc-search-metadata.json' with { type: 'json' };
import _9b4E8UFLyu6lLrSywvIJ from '../dictionary/doc-search-page.json' with { type: 'json' };
import _tY4f9qeR8fJZpV8hiyVo from '../dictionary/doc-search-trigger.json' with { type: 'json' };
import _fA2Ln1NDLnLo7uJL99L3 from '../dictionary/doc-search-view.json' with { type: 'json' };
import _C4YsYHvacBN8SM10s1r1 from '../dictionary/editor-dashboard-metadata.json' with { type: 'json' };
import _oz1yJrltav8PT9tJt4hb from '../dictionary/editor-dashboard-page.json' with { type: 'json' };
import _2z6GVWjJmgh5QLMpwlNs from '../dictionary/email-registration-toast.json' with { type: 'json' };
import _kWA7zDsh7LoXcMayHg6N from '../dictionary/expand-collapse.json' with { type: 'json' };
import _qXHEUVyQbwrDw9umYKg6 from '../dictionary/externals-login-buttons.json' with { type: 'json' };
import _qUTYW0LGPv0uwYPEEuau from '../dictionary/features-section.json' with { type: 'json' };
import _2XyZrLfwPJUxZkL8WUDg from '../dictionary/footer.json' with { type: 'json' };
import _fZM0pfdqjh18OByTe9JB from '../dictionary/landing-section-action-button.json' with { type: 'json' };
import _3g1b4CxH30YpIZfv7M1M from '../dictionary/landing-section.json' with { type: 'json' };
import _pmLnKDWKGvXIFRm2eZsZ from '../dictionary/loader.json' with { type: 'json' };
import _BMZgKrNbYN7Zdju3riIh from '../dictionary/locale-metadata.json' with { type: 'json' };
import _8I7QF4ykqKu4q0IwayoV from '../dictionary/locale-switcher-content.json' with { type: 'json' };
import _yUWEeWAHWbnf0uDIHCab from '../dictionary/locale-switcher.json' with { type: 'json' };
import _dJvo7z9xcOxz3sKP1eMA from '../dictionary/login-metadata.json' with { type: 'json' };
import _nW69dmyi6I1sBKhmJmmM from '../dictionary/long-press-message.json' with { type: 'json' };
import _SNL1SXPvYa3a22SuVVZU from '../dictionary/markdown-section.json' with { type: 'json' };
import _ZXZdN0c4gcjCIUZR6X16 from '../dictionary/mcp-message.json' with { type: 'json' };
import _bM7xCx44ux3KUNTHoy4D from '../dictionary/members-form-schema.json' with { type: 'json' };
import _SaZmMQ1mpb8pMTuf6u6k from '../dictionary/multilingual-section.json' with { type: 'json' };
import _OQJbxvu7R6rocyG0HEdX from '../dictionary/nav-titles.json' with { type: 'json' };
import _UDAtPDKTtRdqJmgtdors from '../dictionary/navbar.json' with { type: 'json' };
import _lFGmdplSYaeOKZU6bQ3o from '../dictionary/navigation-view.json' with { type: 'json' };
import _FYAeFsaVIT2XzxSK98S0 from '../dictionary/new-members-form-schema.json' with { type: 'json' };
import _2HXwlvRtD4tDRPWRgUqh from '../dictionary/no-application-url-view.json' with { type: 'json' };
import _ONtUuFuTfcoMDMMH0II8 from '../dictionary/node-type-selector.json' with { type: 'json' };
import _eFObs13yrqrl5kO3B5PO from '../dictionary/not-found-metadata.json' with { type: 'json' };
import _krJZW0WZl5tC78tvAb8S from '../dictionary/not-found.json' with { type: 'json' };
import _q4afqCmqQ9FZMZOZLr3d from '../dictionary/onboard-page.json' with { type: 'json' };
import _L320l6qPqFBhKHXUmIsq from '../dictionary/onboarding-metadata.json' with { type: 'json' };
import _eCWYwqtxqVwfgV9dFD2l from '../dictionary/organization-dashboard-metadata.json' with { type: 'json' };
import _2Rlmmp23qywjlQYqDWWw from '../dictionary/organization-dashboard-page.json' with { type: 'json' };
import _CtPNj5qtpSyHE0TdejjT from '../dictionary/organization-form-schema.json' with { type: 'json' };
import _lG4SyzhgyYBpMiIBrph7 from '../dictionary/organization-form.json' with { type: 'json' };
import _UCxRPiFFoU7fLQD7bJrw from '../dictionary/organization-members-form.json' with { type: 'json' };
import _WROExNqCCxByH6g9QGsa from '../dictionary/organization-plan.json' with { type: 'json' };
import _1ZKFnaQnKdr1F5RlOEZi from '../dictionary/payment-step.json' with { type: 'json' };
import _hpdCp9YUlHpfNebfmfrs from '../dictionary/playground-metadata.json' with { type: 'json' };
import _XnJipno7UrBMie3Pm6fe from '../dictionary/playground-page.json' with { type: 'json' };
import _G20cDjrWb9DOLihAqy0m from '../dictionary/pricing-metadata.json' with { type: 'json' };
import _UUHysZzcMxKj5oHWpHr5 from '../dictionary/pricing.json' with { type: 'json' };
import _CiHOkIwPxIIw8E012ADl from '../dictionary/product-header-structured-data.json' with { type: 'json' };
import _n0kxiOyA9nni7ktUQ6y2 from '../dictionary/product-hunt.json' with { type: 'json' };
import _sc8Tnm8CAKQhaLB5gUv0 from '../dictionary/profile-dashboard-metadata.json' with { type: 'json' };
import _pDOtr2MhIPT1PqcBFn3V from '../dictionary/profile-dashboard-page.json' with { type: 'json' };
import _Fd73SlWX5JIOLAKD8917 from '../dictionary/profile-form-schema.json' with { type: 'json' };
import _Pg9UsCiAhVUiExMObtJr from '../dictionary/profile-form.json' with { type: 'json' };
import _2lzpqE7z31vbYzenkSMq from '../dictionary/project-config-detail.json' with { type: 'json' };
import _LOXeq45l6sr6qX7LAh16 from '../dictionary/project-dashboard-metadata.json' with { type: 'json' };
import _AqfEpHu1lI6zoyhpjOXh from '../dictionary/project-form-schema.json' with { type: 'json' };
import _qNW0CighaOGBnnPgchKO from '../dictionary/project-form.json' with { type: 'json' };
import _z8gV8ZZP9CHpFA5z7hKk from '../dictionary/project-list.json' with { type: 'json' };
import _xm9ba1XhfCiuTrUoBZvY from '../dictionary/project-members-form.json' with { type: 'json' };
import _ybsD7fL2y5Z26pMIKRb0 from '../dictionary/projects-dashboard-page.json' with { type: 'json' };
import _ubgcO7HNl0MNd5nkqojB from '../dictionary/register-metadata.json' with { type: 'json' };
import _egZKRUq0nAuPj1fUMQrh from '../dictionary/register-password-schema.json' with { type: 'json' };
import _mYzyqqKNU9xue6KeVNM9 from '../dictionary/register-step.json' with { type: 'json' };
import _K5XpAxRgjsV8t5jMt1r6 from '../dictionary/remove-member-modal.json' with { type: 'json' };
import _TiRulskWolAfWFNOMKrL from '../dictionary/reset-password-metadata.json' with { type: 'json' };
import _I4s6aTlkufZqMq0oOf0d from '../dictionary/reset-password-page.json' with { type: 'json' };
import _q9WhfuS6sKIJc3fNWIOS from '../dictionary/save-dictionary-details.json' with { type: 'json' };
import _1hSHIPIEIE5vELLmlYwy from '../dictionary/set-up-organization-schema.json' with { type: 'json' };
import _L6YxYkt1ZEa5FWuMthtn from '../dictionary/set-up-organization-step.json' with { type: 'json' };
import _dtLQbKrZUyicnqH7KklA from '../dictionary/sign-in-page.json' with { type: 'json' };
import _SQWVQJ6TPsfOREEpOF5j from '../dictionary/sign-in-schema.json' with { type: 'json' };
import _AEHvrvzJnFo2iTew6sy6 from '../dictionary/sign-in.json' with { type: 'json' };
import _RQpIiua9uNzzJCPJkMJS from '../dictionary/sign-up-form.json' with { type: 'json' };
import _P3Mz2mzQn1TlP9YrFPNx from '../dictionary/sign-up-page.json' with { type: 'json' };
import _kYbWMScTklIPkctIZMmm from '../dictionary/sign-up-schema.json' with { type: 'json' };
import _qrzZOpRKppSHlgHc4PZT from '../dictionary/software-application-structured-data.json' with { type: 'json' };
import _bc34OzZAHb8HVCtGmgvf from '../dictionary/step-layout.json' with { type: 'json' };
import _9wrw1X7dOgfUWUin0Edm from '../dictionary/structure-view.json' with { type: 'json' };
import _GJVFGCRUF5qj0PZP4kOJ from '../dictionary/summarize-ai.json' with { type: 'json' };
import _aelLNTr6eByqCB9UMvUF from '../dictionary/table.json' with { type: 'json' };
import _XRywHfEwonUG7OcUBu5R from '../dictionary/tag-dashboard-page.json' with { type: 'json' };
import _0qvVqG6eu3AfIBlPfa0n from '../dictionary/tag-details.json' with { type: 'json' };
import _esyvggGrgdMR0xITLAr1 from '../dictionary/tag-form-schema.json' with { type: 'json' };
import _5F7224m3P1TSIZ17ENrs from '../dictionary/tag-form.json' with { type: 'json' };
import _8OW3WZvRfzYwzwkuh0fh from '../dictionary/tag-list.json' with { type: 'json' };
import _aJ70aY09nvCbwBUL6PvR from '../dictionary/tags-dashboard-metadata.json' with { type: 'json' };
import _T6LQjIfUwV1yb4CXc1Z5 from '../dictionary/tags-dashboard-page.json' with { type: 'json' };
import _Dh9KTQxLqeAhoThjbONf from '../dictionary/tags-dictionaries-list.json' with { type: 'json' };
import _RKJUO7e8I2EUrEZ5UQs9 from '../dictionary/test.json' with { type: 'json' };
import _K7vNJNgMAPcYKYXRmRzM from '../dictionary/translated-content-message.json' with { type: 'json' };
import _0SX5di8npz0xGTLFdO5i from '../dictionary/verify-email-form.json' with { type: 'json' };
import _B3oDTMP1cqda7oqoNpof from '../dictionary/verify-email-step.json' with { type: 'json' };
import _h6jggOCIVJfHVRffcgZJ from '../dictionary/version-switcher.json' with { type: 'json' };
import _20AR9RS16Y4wU13wkmUB from '../dictionary/visual-editor-section.json' with { type: 'json' };
import _MDpm4xxzqqkZOPkDGb0B from '../dictionary/website-structured-data.json' with { type: 'json' };
import _WUlnEuOiXiNlF3YnGl4K from '../dictionary/why-to-chose-intlayer-section.json' with { type: 'json' };
import _DyoxgnnUejBGrOCALXoq from '../dictionary/youtube-video-message.json' with { type: 'json' };

export default {
  "access-key-creation-form-schema": _Rubn5O8YXA2u0fgzXwb2,
  "access-key-creation-form": _qDuWj4yX0RhG8PsfOC1d,
  "access-key-form": _dOZN9bmrqoOTLekpJOYJ,
  "ai-ab-testing-section": _zwSZb2BTsHDK1brvQ8Sz,
  "application-not-running-view": _QpCa8F5wP4N6xWBj4Ky0,
  "application-template-message": _hoDDBdKXlbehy8u2g4H0,
  "aside-navigation": _n99tfC1RKl3WZHbG4qHU,
  "ask-reset-password-schema": _SStx8Rd5g7uDVYhNdx2i,
  "ask-reset-password": _KD0dTbTzVxqEIuIXxJCZ,
  "autocompletion-section": _1HXkcSnhOewJ1ZoMRr1V,
  "available-techno-section": _PvWAhm67jGuGhOKyUDlT,
  "blog-data": _ZrbFBgGlh1vY2AbJIfN8,
  "blog-metadata": _0yYhbxbyrZXFwwkxbiZg,
  "blog-nav-list": _EnLAfOcC6eW2vDDCqAgb,
  "blog-page": _oOBrVk7CYo9517M8K21T,
  "blog-search-metadata": _Kk1MDtOghdDAFRvzpSPd,
  "blog-search-page": _7ozVyNKLad965Ci4ittQ,
  "breadcrumb": _cuV5vovyi4XLkUjfv95R,
  "change-password-form-schema": _H8VJUHXfjRo0MUa9oit0,
  "change-password-form": _1XxZ7C69o55Dik2V14O4,
  "change-password-metadata": _4wWNCRrDapFlRwepYAJT,
  "change-password-page": _zngZDP7S5Io3oVLH1U4t,
  "change-password-schema": _zG283Lj2mWSk8tdmcfDv,
  "chat-form-related-files": _ZXEkig8nriYIpKnOXJCx,
  "chat-form-section-schema": _TmxohlxNpZaRfXr0jxKJ,
  "chat-form-section": _nSIpJwgOVcdFA2yatCRe,
  "chat": _DRWUOjQqAGAeWnimm3zp,
  "chatbot-modal": _vxPQ6fCHiBgUwBh1qaOb,
  "checking-application-status-view": _6DM8FNpdyHjHeBPQyYpK,
  "code": _S9UlbA7lXSQeJnTqCYg1,
  "common-questions": _DPaz1eG00dA5ZDyVrcg9,
  "confirmation-step": _4fDHWULm1gXajqDSb7z5,
  "content-dashboard-metadata": _fjunpeKkZHQ2PT4ZNEmi,
  "content-dashboard-page": _rv5tkZ6SV35wtu732rNo,
  "contribution-message": _DFzXxuXWvtF46pzT4Bja,
  "copy-button": _IIOKVlIhpT3qANCzKUoE,
  "copy-markdown-message": _gGyuqhhLmfK9CEN5dH3V,
  "creative-work-structured-data": _fV9NxlqkiD724MnBwVGW,
  "dashboard-footer": _G7pzOWc73BUWhfXFtd9l,
  "dashboard-metadata": _RURE2w802HgLU4gifh6g,
  "dashboard-navbar-content": _2YPnvvo94LjGqic49gjg,
  "dashboard-navbar": _f0IlBnDOrqvG27rBBcYY,
  "dashboard-not-found-metadata": _zuJAuRCjHMdF6TZMFn3q,
  "dashboard-page": _ujM32TFZL3odMNOQmL6r,
  "define-password-form-schema": _Zo5txVhGAayAVaYAhCf9,
  "define-password-form": _eswpsPWshJVsB6Dg9mpD,
  "define-password-schema": _VWpN5AtM9HjSVFc7rtNG,
  "define-password-step": _r2jO5XMZbTRQUolEwZFf,
  "delete-organization-modal": _CNcknTFEjXDqnIUf9XP1,
  "delete-project-modal": _bJXz9XOof6DY8ka4HJmu,
  "delete-tag-modal": _RfND88POX3Kon4BE6L7U,
  "demo-metadata": _5tA8DSvPYbi88Ratx0y9,
  "demo-page": _6hXQMVDjVsdGK7xZjQx0,
  "demo-section": _gIk1zGlGNgsRU15suzNI,
  "dictionary-dashboard-page": _82aWgK59kQ7zMcQPNOaz,
  "dictionary-detail-schema": _UTmzxtqEhL6wZLtpG4Uy,
  "dictionary-details": _JW9tWj8MQQ6hyrw8SQig,
  "dictionary-edition-drawer": _SLU18jMAUfibbMzixryz,
  "dictionary-field-editor": _kHdY9BDpbfTBNYC2kDja,
  "dictionary-form-schema": _RxrBkOPTfxqSf8R6qJ9w,
  "dictionary-form": _W5HL7v534FXijqAH38Lr,
  "dictionary-list-drawer": _7kZ5YMkTxk1Fg7uin7rq,
  "doc-chat-metadata": _dLmfDoQjKGI1ssgc3nz9,
  "doc-chat-page": _yJLfeAGJmRUuqjojKBmx,
  "doc-data": _icrW9FhwyTfQIxYOnzO6,
  "doc-header": _B6XvgSSUlwjG4e0ZZlW1,
  "doc-metadata": _IgBufdtIXdaOre68fnNC,
  "doc-nav-list": _zB10Frhg2ujd3JP0gQPa,
  "doc-page": _uC12y7L5eSgZoywNrNxz,
  "doc-search-metadata": _LFwhe21VVbv2IWn8lI1x,
  "doc-search-page": _9b4E8UFLyu6lLrSywvIJ,
  "doc-search-trigger": _tY4f9qeR8fJZpV8hiyVo,
  "doc-search-view": _fA2Ln1NDLnLo7uJL99L3,
  "editor-dashboard-metadata": _C4YsYHvacBN8SM10s1r1,
  "editor-dashboard-page": _oz1yJrltav8PT9tJt4hb,
  "email-registration-toast": _2z6GVWjJmgh5QLMpwlNs,
  "expand-collapse": _kWA7zDsh7LoXcMayHg6N,
  "externals-login-buttons": _qXHEUVyQbwrDw9umYKg6,
  "features-section": _qUTYW0LGPv0uwYPEEuau,
  "footer": _2XyZrLfwPJUxZkL8WUDg,
  "landing-section-action-button": _fZM0pfdqjh18OByTe9JB,
  "landing-section": _3g1b4CxH30YpIZfv7M1M,
  "loader": _pmLnKDWKGvXIFRm2eZsZ,
  "locale-metadata": _BMZgKrNbYN7Zdju3riIh,
  "locale-switcher-content": _8I7QF4ykqKu4q0IwayoV,
  "locale-switcher": _yUWEeWAHWbnf0uDIHCab,
  "login-metadata": _dJvo7z9xcOxz3sKP1eMA,
  "long-press-message": _nW69dmyi6I1sBKhmJmmM,
  "markdown-section": _SNL1SXPvYa3a22SuVVZU,
  "mcp-message": _ZXZdN0c4gcjCIUZR6X16,
  "members-form-schema": _bM7xCx44ux3KUNTHoy4D,
  "multilingual-section": _SaZmMQ1mpb8pMTuf6u6k,
  "nav-titles": _OQJbxvu7R6rocyG0HEdX,
  "navbar": _UDAtPDKTtRdqJmgtdors,
  "navigation-view": _lFGmdplSYaeOKZU6bQ3o,
  "new-members-form-schema": _FYAeFsaVIT2XzxSK98S0,
  "no-application-url-view": _2HXwlvRtD4tDRPWRgUqh,
  "node-type-selector": _ONtUuFuTfcoMDMMH0II8,
  "not-found-metadata": _eFObs13yrqrl5kO3B5PO,
  "not-found": _krJZW0WZl5tC78tvAb8S,
  "onboard-page": _q4afqCmqQ9FZMZOZLr3d,
  "onboarding-metadata": _L320l6qPqFBhKHXUmIsq,
  "organization-dashboard-metadata": _eCWYwqtxqVwfgV9dFD2l,
  "organization-dashboard-page": _2Rlmmp23qywjlQYqDWWw,
  "organization-form-schema": _CtPNj5qtpSyHE0TdejjT,
  "organization-form": _lG4SyzhgyYBpMiIBrph7,
  "organization-members-form": _UCxRPiFFoU7fLQD7bJrw,
  "organization-plan": _WROExNqCCxByH6g9QGsa,
  "payment-step": _1ZKFnaQnKdr1F5RlOEZi,
  "playground-metadata": _hpdCp9YUlHpfNebfmfrs,
  "playground-page": _XnJipno7UrBMie3Pm6fe,
  "pricing-metadata": _G20cDjrWb9DOLihAqy0m,
  "pricing": _UUHysZzcMxKj5oHWpHr5,
  "product-header-structured-data": _CiHOkIwPxIIw8E012ADl,
  "product-hunt": _n0kxiOyA9nni7ktUQ6y2,
  "profile-dashboard-metadata": _sc8Tnm8CAKQhaLB5gUv0,
  "profile-dashboard-page": _pDOtr2MhIPT1PqcBFn3V,
  "profile-form-schema": _Fd73SlWX5JIOLAKD8917,
  "profile-form": _Pg9UsCiAhVUiExMObtJr,
  "project-config-detail": _2lzpqE7z31vbYzenkSMq,
  "project-dashboard-metadata": _LOXeq45l6sr6qX7LAh16,
  "project-form-schema": _AqfEpHu1lI6zoyhpjOXh,
  "project-form": _qNW0CighaOGBnnPgchKO,
  "project-list": _z8gV8ZZP9CHpFA5z7hKk,
  "project-members-form": _xm9ba1XhfCiuTrUoBZvY,
  "projects-dashboard-page": _ybsD7fL2y5Z26pMIKRb0,
  "register-metadata": _ubgcO7HNl0MNd5nkqojB,
  "register-password-schema": _egZKRUq0nAuPj1fUMQrh,
  "register-step": _mYzyqqKNU9xue6KeVNM9,
  "remove-member-modal": _K5XpAxRgjsV8t5jMt1r6,
  "reset-password-metadata": _TiRulskWolAfWFNOMKrL,
  "reset-password-page": _I4s6aTlkufZqMq0oOf0d,
  "save-dictionary-details": _q9WhfuS6sKIJc3fNWIOS,
  "set-up-organization-schema": _1hSHIPIEIE5vELLmlYwy,
  "set-up-organization-step": _L6YxYkt1ZEa5FWuMthtn,
  "sign-in-page": _dtLQbKrZUyicnqH7KklA,
  "sign-in-schema": _SQWVQJ6TPsfOREEpOF5j,
  "sign-in": _AEHvrvzJnFo2iTew6sy6,
  "sign-up-form": _RQpIiua9uNzzJCPJkMJS,
  "sign-up-page": _P3Mz2mzQn1TlP9YrFPNx,
  "sign-up-schema": _kYbWMScTklIPkctIZMmm,
  "software-application-structured-data": _qrzZOpRKppSHlgHc4PZT,
  "step-layout": _bc34OzZAHb8HVCtGmgvf,
  "structure-view": _9wrw1X7dOgfUWUin0Edm,
  "summarize-ai": _GJVFGCRUF5qj0PZP4kOJ,
  "table": _aelLNTr6eByqCB9UMvUF,
  "tag-dashboard-page": _XRywHfEwonUG7OcUBu5R,
  "tag-details": _0qvVqG6eu3AfIBlPfa0n,
  "tag-form-schema": _esyvggGrgdMR0xITLAr1,
  "tag-form": _5F7224m3P1TSIZ17ENrs,
  "tag-list": _8OW3WZvRfzYwzwkuh0fh,
  "tags-dashboard-metadata": _aJ70aY09nvCbwBUL6PvR,
  "tags-dashboard-page": _T6LQjIfUwV1yb4CXc1Z5,
  "tags-dictionaries-list": _Dh9KTQxLqeAhoThjbONf,
  "test": _RKJUO7e8I2EUrEZ5UQs9,
  "translated-content-message": _K7vNJNgMAPcYKYXRmRzM,
  "verify-email-form": _0SX5di8npz0xGTLFdO5i,
  "verify-email-step": _B3oDTMP1cqda7oqoNpof,
  "version-switcher": _h6jggOCIVJfHVRffcgZJ,
  "visual-editor-section": _20AR9RS16Y4wU13wkmUB,
  "website-structured-data": _MDpm4xxzqqkZOPkDGb0B,
  "why-to-chose-intlayer-section": _WUlnEuOiXiNlF3YnGl4K,
  "youtube-video-message": _DyoxgnnUejBGrOCALXoq
};
